import { render } from "./ObjectCard.vue?vue&type=template&id=42300aeb"
import script from "./ObjectCard.vue?vue&type=script&lang=js"
export * from "./ObjectCard.vue?vue&type=script&lang=js"

import "./ObjectCard.vue?vue&type=style&index=0&id=42300aeb&lang=scss"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__